import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";

//PROJECT IMPORTS
import Close from "./Close";
import ApproveGroupSavings from "./Approve";
import UndoApproval from "./UndoApproval";
import Reject from "./Reject";
import ModifyApplication from "./ModifyApplication";
import Activate from "./Activate";
import Withdraw from "./Withdraw";
import Deposit from "./Deposit";

const GsimApplicationMainActionPage = (props) => {
  const { userData } = props;
  const { state } = useLocation();

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "modify application":
        return <ModifyApplication userData={userData} />;
      case "reject":
        return <Reject userData={userData} />;
      case "approve":
        return <ApproveGroupSavings userData={userData} />;
      case "undo approval":
        return <UndoApproval userData={userData} />;
      case "withdraw":
        return <Withdraw userData={userData} />;
      case "deposit":
        return <Deposit userData={userData} />;
      case "close":
        return <Close userData={userData} />;
      case "activate":
        return (
          <Activate userData={userData} pageTitleParam={state?.actionLabel} />
        );

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GsimApplicationMainActionPage);
